// import Tooltip from '@mui/material/Tooltip';
import React from 'react'
import '../assets/css/Button.scss'

const Button = (props) => (
    // <Tooltip
    //     title={
    //         <>
    //             <span>{props.title}</span>
    //             <br />
    //             {props.shortCut && <span>{props.shortCut}</span>}
    //         </>
    //     }
    //     placement='top'
    //     arrow
    // >
        <button
            id={props?.id}
            onClick={props.handleClick}
            className={props.className}
        >
            {props.children}
        </button>
    // </Tooltip>
)

export default Button
